import { ApiResponseObject } from "../../../types";
import { axios } from "../../../utils/axios";
import {
  IIzvestajiIsporuceneMarkicePayload,
  IIzvestajiIsporuceneMarkiceProps,
  PeriodicReportListFilterPayload,
  PeriodicReportListResponse,
} from "./periodicReports.types";

const createIzvestajiIsporuceneMarkice = (
  payload: IIzvestajiIsporuceneMarkicePayload
): Promise<ApiResponseObject<IIzvestajiIsporuceneMarkiceProps>> => {
  return axios.post("/izvestajiIsporuceneMarkice", payload);
};

const generatePeriodicReport = (): Promise<ApiResponseObject<boolean>> => {
  return axios.get("/PeriodicniIzvestajGenerisanje");
};

const getPeriodicReportList = (
  payload?: Partial<PeriodicReportListFilterPayload>
): Promise<ApiResponseObject<PeriodicReportListResponse>> => {
  return axios.post("/periodic-report-list", payload);
};

export const periodicReportsRepo = {
  createIzvestajiIsporuceneMarkice,
  generatePeriodicReport,
  getPeriodicReportList,
};
